<template>
<div>
      <div :class="[preClass ,'container']">
        <base-table :data="assetsAnalysis"></base-table>
        <div class="tips-wrap">
          <p style="color:#13C2C2">提示：请定期盘点账上固定资产与实际固定资产的一致性</p>
        </div>
    </div>
</div>

</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      preClass: "assets-analyse",
      assetsAnalysis:[],
      label:'固定资产分析',
      headers: ["资产名称", "资产余额"],

    };
  },
    computed: {
    ...mapGetters(["currClient", "currDate"]),
    title(){
      return  this.currDate.substr(0,7).replace('-','/')+this.label
    }

  },
  mounted() {
    this.getData()
  },
  methods: {
       getData() {
      this.$store.commit('app/SET_LOADING_STATUS', true)
      this.assetsAnalysis = [];
      let params = {
        begin_ym: this.currDate,
        end_ym: this.currDate,
        page: 1,
        rows: 99999999
      };
      this.$axios.post("/account-book/account-balance", params).then(res => {
        console.log('固定资产分析',res)
        if (res.success && res.rows) {
          res.rows.forEach(item => {
            if (item.name === '固定资产') {
                  this.assetsAnalysis = this.getChildren(item.children)
            }
          });
          console.log(' this.assetsAnalysis', this.assetsAnalysis)
        }
      }).finally(_=>{
          this.$store.commit('app/SET_LOADING_STATUS', false)
      });
    },
    getChildren(data){
      let arr = []
      if(data){
            data.forEach(item=>{
              if(item.is_leaf===1&&item.end_balance>0){
                arr.push({
                        ...item,
                        title: item.name,
                        value: item.end_balance,
                        align: "around",
                        color: "blue",
                        filter: "toThousandFilter"
                })
              }else if(item.children) {
              arr =  arr.concat(this.getChildren(item.children))
              }

            })
      }

      return arr
    },
    handleTableClick(){
      this.$refs.detail.show = true
    }
  }
};
</script>

<style lang='less'>
.assets-analyse{
  &-title{

  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/financial-report/assets-analyse/index.vue